module.exports = __webpack_public_path__ + "img/graphic-bean-black-rice-cereal.e2a60512.jpg";